<template>
    <div class="device-targeting campaign-step">
        <div class="step-header">
            <div class="step-icon">
                <img src="/images/eye.svg" alt="Видимость и таргетинг по устройствам" />
            </div>
            <h2>{{ $t('messages.device_targeting_title') }}</h2>
        </div>

        <div class="settings-content">
            <Viewability :data="localData" @update="updateViewabilityData" />
            <DeviceTypes :data="localData" :device-types="deviceTypes" @update="updateDeviceData" />
            <DeviceSegments :operating-systems="operatingSystems" :selected="localData.operatingSystemIds"
                @update-devices="updateTargetingData" />

        </div>
    </div>
</template>

<script>
import Viewability from './DeviceTargeting/Viewability.vue';
import DeviceSegments from './DeviceTargeting/DeviceSegments.vue';
import DeviceTypes from './DeviceTargeting/DeviceTypes.vue';

export default {
    name: "DeviceTargeting",
    components: {
        Viewability,
        DeviceTypes,
        DeviceSegments
    },
    props: {
        campaign: {
            type: Object,
            default: () => ({})
        },
        deviceTypes: {
            type: Array,
            default: () => []
        },
        operatingSystems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localData: {
                viewability: false,
                viewability_percentage: 0,
                devices: [],
                operatingSystemIds: []
            }
        };
    },
    mounted() {
        this.initializeData();
    },
    watch: {
        campaign: {
            handler(newCampaign) {
                if (newCampaign) {
                    this.initializeData();
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        initializeData() {
            if (this.campaign) {
                // Инициализируем данные видимости
                this.localData.viewability = Boolean(this.campaign.viewability);
                this.localData.viewability_percentage = this.campaign.viewability_percentage || 0;

                // Инициализируем устройства
                if (this.campaign.device_types && this.campaign.device_types.length > 0) {
                    this.localData.devices = this.campaign.device_types.map(device => device.id);
                } else {
                    // По умолчанию выбираем все доступные устройства
                    this.localData.devices = this.deviceTypes.map(device => device.id);
                }

                // Инициализируем операционные системы
                if (this.campaign.operating_systems && this.campaign.operating_systems.length > 0) {
                    this.localData.operatingSystemIds = this.campaign.operating_systems.map(os => os.id);
                } else {
                    this.localData.operatingSystemIds = [];
                }
                // Do not emit during initialization — parent owns initial state
            }
        },
        updateViewabilityData(data) {
            this.localData.viewability = data.viewability;
            this.localData.viewability_percentage = data.viewability_percentage;
            this.updateData();
        },

        updateDeviceData(data) {
            // Accept either an array (from DeviceSegments) or an object { devices: [...] } (from DeviceSelection)
            if (Array.isArray(data)) {
                this.localData.devices = data;
            } else if (data && Array.isArray(data.devices)) {
                this.localData.devices = data.devices;
            }
            this.updateData();
        },

        updateTargetingData(operatingSystemIds) {
            this.localData.operatingSystemIds = operatingSystemIds;
            this.updateData();
        },

        updateData() {
            this.$emit('update', this.localData);
        }
    }
};
</script>
